import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { Listing } from '@/types'
import structure from '@/structure'
import { breakpoints, colors } from '@/styles'
import List from '@/features/ListingsList/list'
import { H4 } from '@/components/text'

const Wrapper = styled.div`
  margin: 0 20px;
  width: 100%;
`

const Content = styled.div`
  margin: 0 auto;
  max-width: ${structure.page.width}px;
`

const Header = styled.div`
  width: 100%;
  margin: 0 auto;
`

const SectionTitle = styled(H4)`
  color: ${colors.regular};
  margin: 0 0 32px;
`

const ListWrapper = styled.div`
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    margin: 0 -20px;
  }
`

interface Props {
  data: Listing[]
}

const SimilarListings: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation()
  return data && !!data.length ? (
    <Wrapper>
      <Content>
        <Header>
          <SectionTitle as="h2">
            {t(
              'listing:b.similar_listings.view.similar_listings.title',
              'Similar Listings for Rent'
            )}
          </SectionTitle>
        </Header>
        <ListWrapper>
          <List listings={data} noSchema />
        </ListWrapper>
      </Content>
    </Wrapper>
  ) : null
}

export default SimilarListings
